// extracted by mini-css-extract-plugin
module.exports = {"warnings":"styles_warnings__5k4F3","warningsBanner":"styles_warningsBanner__iZJ9s"};